module.exports = __webpack_public_path__ + "img/positive.6f7a6473.svg";